<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>
        <div>
          <div class="info--text">
            <v-icon medium>router</v-icon>
            <strong>Discrete Data</strong>
          </div>
          <div class="body-2">
            Summary
          </div>
        </div>
      </v-toolbar-title>
    </v-toolbar>
    <v-divider />
    <v-card v-if="wideForm" class="card-bg-4">
      <DiscreteDataSummary class="mb-2" />
      <v-layout>
        <v-flex xs12 lg6>
          <DiscreteInformation class="mr-1" :editForm="editForm" />
        </v-flex>
        <v-flex xs12 lg6>
          <Aliases class="ml-1" :editForm="editForm" />
        </v-flex>
      </v-layout>
    </v-card>
    <v-card v-else class="card-bg-4">
      <DiscreteDataSummary class="mb-2" />
      <DiscreteInformation class="mb-2" :editForm="editForm" />
      <Aliases :editForm="editForm" />
    </v-card>
  </div>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const dataSources = createNamespacedHelpers('datasource')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  import DiscreteInformation from './Details/DiscreteInformation'
  import DiscreteDataSummary from './Details/DiscreteDataSummary'

  import Aliases from './ManageAliases/Aliases'
  export default {
    components: {
      DiscreteInformation,
      DiscreteDataSummary,
      Aliases,
    },
    props: {
      editForm: Boolean,
      wideForm: Boolean,
    },
    computed: {
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceIndexByType']),
      ...dataSources.mapGetters(['dataSourceIndex']),
      dataSource() {
        return this.currentFeatureDataSourceIndexByType[SOURCE_TYPES.discreteEnvirodata]
      },
      discreteStation() {
        if (!this.dataSource) return
        let dataSourceId = this.dataSource.SourceId

        let currentFeatureDataSourceIndexByType = this.dataSourceIndex[SOURCE_TYPES.discreteEnvirodata]
        if (!currentFeatureDataSourceIndexByType) return
        let discreteStation = currentFeatureDataSourceIndexByType[dataSourceId]
        return discreteStation
      },
    },
  }
</script>